// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zQNz","inner":"Footer_inner__2SIYx","nextIcon":"Footer_nextIcon__2xUa2","innerLeft":"Footer_innerLeft__3uUQh"};